module.exports = __webpack_public_path__ + "static/media/step-1-wash-hands.07f89ba4.svg";